import { CURRENCY } from '@toni/commerce-api-types'

export const mapCurrency = (price?: number | null, currency?: CURRENCY | null): string => {
  if (price === undefined || price === null) return ''
  if (!currency) return price.toString() || ''
  let formatter
  switch (currency) {
    case CURRENCY.GBP:
      formatter = new Intl.NumberFormat('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      return `£${formatter.format(price)}`
    case CURRENCY.EUR:
      formatter = new Intl.NumberFormat('de', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      return `${formatter.format(price)} €`
    case CURRENCY.USD:
      formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      return `$${formatter.format(price)}`
    default:
      return price?.toString() || ''
  }
}
